import type { JwtResponse } from '@/models/JwtResponse'
import type { UsuarioAutenticacao } from '@/models/UsuarioAutenticacao'
import type { AtualizarPerfilRequest } from '@/models/request/admin/AtualizarPerfilRequest'
import type { AlterarSenhaRequest } from '@/models/request/admin/AlterarSenhaRequest'
import api from '@/plugins/axios'

class AuthenticationService {
  private static readonly BASE_URL = '/auth'

  async login(authRequest: UsuarioAutenticacao): Promise<JwtResponse> {
    const response = await api.post<JwtResponse>(`${AuthenticationService.BASE_URL}/login`, authRequest)
    const data = response.data as JwtResponse
    // Token is no longer in the JSON body; read from Authorization header
    const authHeader = response.headers['authorization']
    if (authHeader && authHeader.startsWith('Bearer ')) {
      data.token = authHeader.substring(7)
    }
    return data
  }

  async logout(): Promise<void> {
    await api.post<void>(`${AuthenticationService.BASE_URL}/logout`)
  }

  /** Lightweight endpoint: returns id, name, email, roles, permissions (used by authStore.checkAuth). */
  async usuarioLogado(): Promise<JwtResponse> {
    const { data } = await api.get<JwtResponse>(`${AuthenticationService.BASE_URL}/usuario-logado`)
    return data
  }

  /** Full profile endpoint: returns complete UsuarioResponse (used by MeuPerfilView). */
  async getMe(): Promise<JwtResponse> {
    const { data } = await api.get<JwtResponse>('/auth/me')
    return data
  }

  async updateMe(request: AtualizarPerfilRequest): Promise<JwtResponse> {
    const { data } = await api.put<JwtResponse>('/auth/me', request)
    return data
  }

  async alterarSenha(request: AlterarSenhaRequest): Promise<void> {
    await api.put('/auth/me/senha', request)
  }

  setAuthHeader(token: string | null): void {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    } else {
      delete api.defaults.headers.common['Authorization']
    }
  }
}

export default new AuthenticationService()
